<template>
  <div :class="$style.newGame">
    <div :class="$style.header">
      <span>新游推荐</span>
      <img :src="`${this.$cdnLink}/suspend/tongyong/guanbi.png`" alt="" @click="close" />
    </div>
    <main>
      <ul>
        <li v-for="(item, index) in gameList" :key="`${index}`">
          <img :src="item.game_icon" alt="" />
          <div :class="$style.txt">
            <p>{{ item.game_name }}</p>
            <div :class="$style.tags" v-if="item.list_type === 2">
              <span
                v-for="(tagItem, tagIndex) in item.tags"
                :style="`color: ${tagItem.label_info}; border: 1px solid ${tagItem.label_info}`"
                :key="`${tagIndex}`"
                >{{ tagItem.label_name }}
              </span>
            </div>
            <p :class="$style.detail" v-if="item.list_type === 1">{{ item.game_detail }}</p>
             <p :class="$style.detail" v-if="item.list_type === 2">{{ item.score }}分 | {{ item.version }}版本 | {{ item.game_detail }}</p>
          </div>
          <button @click="downloadUrl(item)">我要试玩</button>
        </li>
      </ul>
      <div v-if="boxStatus!=0 || jump_mode == 3" @click="showMore" :class="$style.showMore">打开盒子app发现更多好游戏</div>
    </main>
    <BoxDownLoad v-if="boxDownLoadShow" @close="boxDownLoadShow=false" :type="boxType"></BoxDownLoad>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { boxDownloadUrl, wxBoxDownloadUrl, boxMainUrl, wxBoxMainUrl, boxNewGameUrl, wxBoxNewGameUrl } from '@/config';
import { gameOpenDownloads, gameDetail2sdk, boxMainPage2sdk, downloadProgress2H5, skipWXBox2Sdk } from '@/bridge/AppJsBridge';
import { generJumpLink } from '@/libs/business/box'
import BoxDownLoad from './common/boxDownload.vue';
import { buryReport, buryReportV2 } from '@/libs/business/account';

export default {
  name: '',
  data() {
    return {
      gameType: '',
      boxStatus: '',
      boxDownLoadShow: false,
      boxType: 'bt'
    };
  },
  mounted() {
    this.gameType = this.$getStorage('game_type');
    this.boxStatus = this.$getStorage('box_status');
    this.boxType = this.boxStatus == '1' ? 'bt' : 'wx';
    if (this.gameType === 'boxGame' || this.gameType === 'wxBoxGame') {
      downloadProgress2H5((data) => {
        this.$toast({
          message: data,
          position: 'bottom',
        });
      });
    }
  },
  computed: {
    ...mapState({
      gameList: (state) => state.suspend.newGameList,
      jump_mode: (state) => state.suspend.jump_mode,
    }),
  },
  methods: {
    async downloadUrl(item) {
      buryReportV2('SDK_MENU_NEW_GAME_TRY', {
        new_game_id: item.new_game_appkey,
        new_game_name: item.game_name
      });
      if (item.list_type == 2) {
        if (!['wxBoxGame', 'boxGame'].includes(this.gameType)) {
          const gameUrl = await generJumpLink(item.new_game_appkey || '')
          gameOpenDownloads({
            gameUrl: this.boxStatus == 1 ? gameUrl.boxNewGameUrl : gameUrl.wxBoxNewGameUrl
          })
          this.boxDownLoadShow = true;
        } else if (this.gameType === 'boxGame') {
          gameDetail2sdk({
            appkey: item.new_game_appkey,
            boxUrl: boxDownloadUrl(),
          });
        } else if (this.gameType === 'wxBoxGame') {
          skipWXBox2Sdk({
            event: 'boxGameDetail',
            syAppkey: item.new_game_appkey,
            boxUrl: wxBoxDownloadUrl(),
            routePath: ""
          })
        }
      } else {
        gameOpenDownloads({
          gameUrl: item.game_url,
        });
      }
    },
    close() {
      this.$emit('close');
    },
    async showMore() {
      buryReportV2('SDK_MENU_NEW_GAME_BOX', { type: this.boxStatus == 1 ? 2 : 1 });
      if (!['wxBoxGame', 'boxGame'].includes(this.gameType)) {
        const gameUrl = await generJumpLink()
        gameOpenDownloads({
          gameUrl: this.boxStatus == 1 ? gameUrl.boxMainUrl : gameUrl.wxBoxMainUrl
        })
        this.boxDownLoadShow = true;
      } else {
        if (this.gameType === 'wxBoxGame') {
          skipWXBox2Sdk({
            event: 'boxMainPage',
            syAppkey: "",
            boxUrl: wxBoxDownloadUrl(),
            routePath: ""
          })
        } else {
          boxMainPage2sdk({
            boxUrl: boxDownloadUrl(),
          });
        }
      }
    },
  },
  components: {
    BoxDownLoad
  }
};
</script>

<style lang="scss" module>
@import './common.scss';

.newGame {
  @include common-h5-wrap();
  background: #fcf8f8;
  > main {
    height: calc(100% - 32px);
    overflow-y: auto;
    > ul {
      font-size: 10px;
      > li {
        display: flex;
        align-items: center;
        background: #ffffff;
        border-radius: 4px;
        margin: 8px;
        padding: 8px;
        > img {
          width: 56px;
          margin-right: 15px;
        }
        > .txt {
          > p:nth-child(1) {
            color: #333333;
            font-size: 12px;
            line-height: 14px;
            font-weight: bold;
            margin-bottom: 4px;
            width: 154px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .tags {
            margin-bottom: 4px;
            > span {
              display: inline-block;
              padding: 1px 3px;
              font-size: 10px;
              border-radius: 2px;
              margin-right: 5px;
            }
          }
          .detail {
            color: #9c9c9c;
            font-size: 10px;
            width: 154px;
          }
        }
        > button {
          background: #ff5955;
          border: none;
          color: #ffffff;
          padding: 8px 15px;
          border-radius: 3px;
          margin-left: 10px;
        }
      }
    }
    .showMore {
      font-size: 13px;
      color: #ff5955;
      text-align: right;
      padding-right: 8px;
      margin: 10px 0;
      text-decoration:underline
    }
  }
}
</style>
